export default __webpack_public_path__ + "static/media/oil91.7152159a.jpg";